import { IAgent } from '@d-id/types';

export enum INSIGHTS_DATE_RANGE {
    LAST_6_MONTHS = 'last6months',
    LAST_30_DAYS = 'last30days',
    LAST_7_DAYS = 'last7days',
    YESTERDAY = 'yesterday',
    CUSTOM = 'custom',
}

export const ALL_AGENTS = { preview_name: 'All Agents' } as IAgent;
